<template>
  <div
    class="modal fade ag-modal ag-otp-modal"
    id="otpModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{$t("generatePassword")}}</h3>
        </div>
        <form method="post" @submit.prevent="submitOtp">
          <div class="modal-body" v-if="selectedComputer.ComputerId">
            <div class="ag-modal-form w-100">
              <ul class="ag-modal-form-list">
                <li>
                  <span class="bold-text">{{$t("computername")}} : </span>
                  <span class="value">
                    <li class="form-group">
                      <input
                        type="text"
                        maxlength="191"
                        name="phrase"
                        class="form-control"
                        placeholder="Computer Name"
                        disabled
                        :value="selectedComputer.WindowsComputerName"
                      />
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">{{$t("enterYourPhrase")}} : </span>
                  <span class="value">
                    <li class="form-group">
                      <input
                        type="text"
                        maxlength="191"
                        name="phrase"
                        v-model="phrase"
                        class="form-control"
                        placeholder="Enter Your Phrase"
                        required
                      />
                    </li>
                  </span>
                </li>
                <li class="permission-input">
                  <span class="bold-text">{{$t("permissionToModify")}} : </span>
                  <span class="value">
                    <li class="form-group">
                      <label for="CanChangePolicyProtections">
                        <input
                          type="checkbox"
                          id="CanChangePolicyProtections"
                          value="2"
                          name="otpPermission"
                          v-model="otpPermission.policy"
                        />
                        {{$t("policyProtection")}}
                      </label>
                    </li>
                    <li class="form-group">
                      <label for="ChangeTamperGuard">
                        <input
                          type="checkbox"
                          id="ChangeTamperGuard"
                          value="1"
                          name="otpPermission"
                          v-model="otpPermission.tamper"
                        />
                        {{$t("tamperGuard")}}
                      </label>
                    </li>
                    <li class="form-group">
                      <label for="CanChangeAudit">
                        <input
                          type="checkbox"
                          id="CanChangeAudit"
                          value="4"
                          name="otpPermission"
                          v-model="otpPermission.audit"
                        />
                        {{$t("auditOnly")}}
                      </label>
                    </li>
                  </span>
                </li>
              </ul>
              <ul class="ag-modal-form-list otp-result">
                <li>
                  <span class="bold-text"
                    >{{$t("oneTime")}} :
                  </span>
                  <span class="value">
                    <li class="form-group">
                      <input
                        type="text"
                        maxlength="191"
                        name="otpResult"
                        class="form-control"
                        placeholder="Password will be displayed here"
                        disabled
                        :value="otpResult"
                      />
                    </li>

                    <a
                      type="button"
                      class="copy-button"
                      @click="copy"
                      :disabled="!otpResult"
                    >
                      <i class="ag-icon ag-icon_copy pl-2 ml-2 mr-2"></i>
                    </a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="
                border-0
                ag-button ag-button_radius
                pr-4
                pl-4
                ag-button_secondary
              "
              data-dismiss="modal"
            >
              {{$t("cancel")}}
            </button>
            <button
              type="submit"
              :disabled="!phrase || loading"
              class="
                border-0
                ag-button ag-button_radius
                pr-4
                pl-4
                ag-button_primary
                float-inline-end
              "
            >
              {{$t("generate")}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { notify } from "@kyvg/vue3-notification";

const store = useStore();
export default {
  name: "ag-otp-modal",
  props: {
    selectedComputer: {},
    status: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phrase: null,
      otpPermission: {
        self: false,
        policy: false,
        tamper: false,
        audit: false,
      },
      otpResult: "",
      otpTotal: 0,
      loading: false,
    };
  },
  watch: {
    selectedComputer() {
      this.phrase = null;
      this.otpPermission = {
        self: false,
        policy: false,
        tamper: false,
        audit: false,
      };
      this.otpResult = "";
      this.otpTotal = 0;
      this.loading = false;
    },
    otpPermission: {
      deep: true,
      handler() {
        let total = 0;
        if (this.otpPermission.policy) {
          total += 2;
        }
        if (this.otpPermission.tamper) {
          total += 1;
        }
        if (this.otpPermission.audit) {
          total += 4;
        }
        this.otpTotal = total;
      },
    },
  },
  methods: {
    async submitOtp() {
      this.loading = true;
      const formData = {
        phrase: this.phrase,
        otpPermission: this.otpTotal,
        computerGuid: this.selectedComputer.ComputerId,
      };
      const res = await store.dispatch(GeneralActionTypes.CREATE_OTP, formData);
      this.otpResult = res.entityData;
      this.loading = false;
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.otpResult);
        notify({
          title: "Copied",
          type: "success",
          duration: 3000,
        });
      } catch ($e) {
        notify({
          title: "Cannot copy",
          type: "error",
          duration: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}

.ag-modal-form-list {
  margin-left: 30px;
}

.ag-modal .modal-body label input {
  margin-right: 4px;
}

.ag-modal-form-list li {
  width: 86%;
}

.ag-modal-form-list li .bold-text {
  text-align: left !important;
  width: 33% !important;
}

.copy-button {
  margin-left: -42px;
  position: relative;
  left: 50px;
}

.permission-input {
  width: 84% !important;
  height: 200px;
  border: 1px solid;
  margin-top: 20px;

  .bold-text {
    position: relative;
    top: -100px;
    background: #f8f8f8;
    padding-left: 6px;
    padding-right: 6px;
    margin-left: -6px;
  }

  .value {
    display: block !important;
    // margin-left: 35%;
  }
}
.otp-result {
  margin-top: 20px;
  border-top: 4px solid #164b6c;
}
</style>
